// import PolyfillsCustom from './utility/polyfills';
import CheckboxLists from './checkbox-lists';
import BookSeries from './book-series';
import CopyRightYears from './copyright-years';
import FiltersDownload from './filters-download';
import ShareableLink from './shareable-link';
import RecordsCount from './records-count';
import PublicationIds from './publication-ids';
import RestApi from './utility/restapi';

class MarcRecords {
	constructor() {
		this.initialize();
	}
		
	// PolyfillsCustom.initializePolyfills();
	async initialize() {
		const restApi = new RestApi('/metadata/');
		const recordsCount = new RecordsCount({api: restApi});
		//
		CheckboxLists.init();
		CopyRightYears.init();
		ShareableLink.init();

		/* eslint-disable no-unused-vars */
		const bookSeries = new BookSeries(restApi, recordsCount);
		const filtersDownload = new FiltersDownload(recordsCount);
		const publicationIds = new PublicationIds(filtersDownload);
	}
}

export default MarcRecords;
